<script lang="ts" setup>


</script>
<template>
  <div class="flex items-center gap-4">

  <span class="text-white text-xm va-text-bold">DmG<br/>Verwaltung</span>
  </div>
</template>
